export const API_URL = process.env.API;


// WEBPACK FOOTER //
// src/constants/mainApi.jsx